import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { InformationPopulation } from '../interfaces/information-population';
import { Observable, of, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InformationPopulationService {
  constructor (private http: HttpClient) { };

  getInformationPopulationForRaceId (raceId: string): Observable<InformationPopulation[]> {
    if (raceId == null) {
      throw new Error("No Active Race");
    }
    return this.http.get<InformationPopulation[]>('/api/informationPopulation/raceId/' + raceId);
  };

  getInformationPopulationForRaceIdAndStarSystemId (raceId: string, starSystemId: string): Observable<InformationPopulation[]> {
    if (raceId == null) {
      throw new Error("No Active Race");
    }
    if (starSystemId == null) {
      throw new Error("No Active StarSystem");
    }
    return this.http.get<InformationPopulation[]>('/api/informationPopulation/raceId/' + raceId + '/starSystemId/' + starSystemId);
  }

  getInformationPopulationForRaceIdAndPlanetId (raceId: string, planetId: string): Observable<InformationPopulation> {
    if (raceId == null) {
      throw new Error("No Active Race");
    }
    if (planetId == null) {
      throw new Error("No Active Planet");
    }
    return this.http.get<InformationPopulation>('/api/informationPopulation/raceId/' + raceId + '/planetId/' + planetId);
  }

  getInformationPopulationForOtherRace (raceId: string) {
    if (raceId == null) {
      throw new Error("No Active Race");
    }
    return this.http.get<InformationPopulation[]>('/api/informationPopulation/other/raceId/' + raceId);
  };

  getInformationPopulationForStarSystemId (starSystemId: string) {
    if (starSystemId == null) {
      throw new Error("No Active StarSystem");
    }
    return this.http.get<InformationPopulation[]>('/api/informationPopulation/starSystemId/' + starSystemId);
  }
}

